var React = require('react');

function RectangleChecked (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Rectangle_322","data-name":"Rectangle 322","fill":"#e11e37","stroke":"#b3b3b3","strokeWidth":"1","key":0},[React.createElement("rect",{"width":"32","height":"32","rx":"4","stroke":"none","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"31","height":"31","rx":"3.5","fill":"none","key":1})]),React.createElement("path",{"id":"Path_18","data-name":"Path 18","d":"M1903.214,460.054l6.747,6.885-3.482,3.482","transform":"translate(481.064 -1890.942) rotate(90)","fill":"none","stroke":"#fff","strokeWidth":"2","key":1})]);
}

RectangleChecked.defaultProps = {"id":"Component_37_1","data-name":"Component 37 – 1","width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = RectangleChecked;

RectangleChecked.default = RectangleChecked;
